import React from 'react';
import '../../../App.css';
import Navbar2 from '../Navbar2';
import ServicesComponents from '../ServicesComponents';
import Footer from '../Footer';

function Component() {
  return (
    <>
      <Navbar2/>
      <ServicesComponents/>
      <Footer/>
  </>
  );
}

export default Component;